(function () {
  'use strict';

  const angular = window.angular;

  CustomerFormController.$inject = [
    '$scope',
    'Admin',
    'Var',
    'Customer',
    '$q',
    'AppUtils',
    'LocalStorageService',
    'LANGS',
  ];

  angular.module('app').component('customerForm', {
    template:'<form name="$ctrl.customerForm" class="validate" novalidate ng-show="!$ctrl.saving"><div class="modal-header"><button type="button" class="close" ng-click="$ctrl.modalInstance.dismiss()"><i class="fas fa-times"></i></button> <span translate>{{::($ctrl.customer.id? \'buttons.edit\': \'buttons.create\')}}</span> <span translate>entities.organization.customer.modelName</span></div><div class="modal-body paddingB0"><div class="form-group" show-errors><label class="control-label" for="name-input" translate>entities._all.name</label> <input id="name-input" name="nameInput" ng-model="$ctrl.customer.name" translate-attr="::{placeholder: \'entities._all.name\'}" class="form-control" required><p class="help-block" ng-messages="$ctrl.customerForm.nameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group" show-errors><label class="control-label" for="businessName-input" translate>entities._all.businessName</label> <input id="businessName-input" name="businessNameInput" ng-model="$ctrl.customer.businessName" translate-attr="::{placeholder: \'entities._all.businessName\'}" class="form-control input-sm" required><p class="help-block" ng-messages="$ctrl.updateForm.businessNameInput.$error"><span ng-message="required">You did not enter a field</span></p></div><div class="form-group"><label class="control-label" for="address-input" translate>entities._all.address</label> <input id="address-input" name="address-input" translate-attr="::{placeholder: \'entities._all.address\'}" ng-model="$ctrl.customer.address" class="form-control input-sm"></div><div class="form-group"><label class="control-label" translate>entities._all.country</label><div class="select2-sm"><ui-select ng-model="$ctrl.customer.countryId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.country\' | translate}}">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat="country.id as country in $ctrl.countries | filter: {name: $select.search}"><div ng-bind-html="country.name | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" translate>entities._all.timezone</label><div class="select2-sm"><ui-select ng-model="$ctrl.customer.timeZoneId" theme="select2"><ui-select-match placeholder="{{\'general._select.a\' | translate}} {{\'entities._all.timezone\' | translate}}">{{$select.selected.text}}</ui-select-match><ui-select-choices repeat="timezone.id as timezone in $ctrl.timeZones | filter: {text: $select.search}"><div ng-bind-html="timezone.text | highlight: $select.search"></div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" translate>entities._all.language</label><select class="form-control input-sm" ng-model="$ctrl.customer.language"><option ng-repeat="lang in $ctrl.langs" value="{{lang}}">{{\'entities.organization.customer.languages.\' + lang | translate}}</option></select></div><div class="form-group" ng-class="{\'has-error\': $ctrl.selectedToolkitsInvalid}"><label class="control-label" translate>entities.toolkit.modelNamePl</label><div class="select2-sm"><ui-select ng-required="true" multiple append-to-body="true" ng-model="$ctrl.selectedToolkits" theme="select2"><ui-select-match placeholder="{{::\'general._select.fa\' | translate}} {{::\'entities.toolkit.modelName\' | translate}}">{{$item.name}}</ui-select-match><ui-select-choices repeat="toolkit.id as toolkit in $ctrl.allToolkits | filter: {name: $select.search}"><div>{{toolkit.name}}</div></ui-select-choices></ui-select></div><p class="help-block"></p></div><div class="form-group"><label class="control-label" for="description-input" translate>entities._all.description</label> <textarea id="description-input" name="description-input" ng-model="$ctrl.customer.description" class="form-control input-sm" style="height: 100px"></textarea></div></div><div class="alert alert-warning no-margin text-center" ng-show="$ctrl.saveError">{{$ctrl.saveError}}</div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" ng-click="$ctrl.modalInstance.dismiss()" translate>buttons.cancel</button> <button class="btn btn-primary" ng-if="$ctrl.customer.id" ng-click="$ctrl.saveCustomer()" translate>buttons.update</button> <button class="btn btn-primary" ng-if="!$ctrl.customer.id" ng-click="$ctrl.saveCustomer()" translate>buttons.create</button></div></form><div style="position: relative; height: 210px" ng-show="$ctrl.saving"><spinner css-class="\'small\'" show="$ctrl.saving"></spinner></div>',
    controller: CustomerFormController,
    bindings: {
      modalInstance: '<',
      resolve: '<',
    },
  });

  function CustomerFormController($scope, Admin, Var, Customer, $q, utils, LocalStorageService, LANGS) {
    let vm = this;

    vm.$onInit = function () {
      vm.customer = angular.copy(vm.resolve.customer || {});
      vm.timeZones = vm.resolve.timeZones;
      vm.countries = vm.resolve.countries;
      vm.langs = LANGS;
      vm.saveCustomer = saveCustomer;

      vm.saving = true;
      let promise = utils.Promise.resolve([]);
      if (!vm.customer.id) {
        if (!vm.customer.countryId) {
          const defaultCountry = vm.countries.find((c) => c.iso === 'CL');
          vm.customer.countryId = defaultCountry ? defaultCountry.id : null;
        }

        if (!vm.customer.timeZoneId) {
          const defaultTimeZone = vm.timeZones.find(
            (c) => c.utc && c.utc.indexOf('America/Santiago') !== -1
          );
          vm.customer.timeZoneId = defaultTimeZone ? defaultTimeZone.id : null;
        }

        if (!vm.customer.language) {
          vm.customer.language = 'en';
        }
      } else {
        promise = Customer.prototype$__get__toolkits({
          id: vm.customer.id,
          filter: { order: 'name ASC' },
        }).$promise;
      }

      vm.currentToolkits = [];
      vm.selectedToolkits = [];
      vm.allToolkits = [];
      promise
        .then((toolkits) => {
          vm.currentToolkits = toolkits.map((c) => c.id);
          vm.selectedToolkits = toolkits.map((c) => c.id);

          return Var.prototype$__get__toolkits({ id: Admin.getCachedCurrent().varId }).$promise;
        })
        .then((result) => {
          vm.allToolkits = result;
          vm.saving = false;
        })
        .catch((err) => {
          vm.saving = false;
          console.log(err);
        });
    };

    function saveCustomer() {
      vm.selectedToolkitsInvalid = vm.selectedToolkits.length < 1;
      if (!vm.customerForm.$valid || vm.selectedToolkitsInvalid) {
        $scope.$broadcast('show-errors-check-validity');
        return;
      }

      let current = Admin.getCachedCurrent();

      const toLink = vm.selectedToolkits.filter(
        (toolkit) => vm.currentToolkits.indexOf(toolkit) === -1
      );
      const toUnlink = vm.currentToolkits.filter(
        (toolkit) => vm.selectedToolkits.indexOf(toolkit) === -1
      );

      vm.saving = true;
      let promise;

      if (vm.customer.id) {
        promise = Var.customers.updateById(
          {
            id: current.varId,
            fk: vm.customer.id,
          },
          {
            name: vm.customer.name,
            businessName: vm.customer.businessName,
            address: vm.customer.address,
            description: vm.customer.description,
            timeZoneId: vm.customer.timeZoneId,
            countryId: vm.customer.countryId,
            language: vm.customer.language,
          }
        );
      } else {
        promise = Var.customers.create(
          {
            id: current.varId,
          },
          {
            name: vm.customer.name,
            businessName: vm.customer.businessName,
            address: vm.customer.address,
            description: vm.customer.description,
            timeZoneId: vm.customer.timeZoneId,
            countryId: vm.customer.countryId,
            language: vm.customer.language,
          }
        );
      }

      let customer;
      promise.$promise
        .then((response) => {
          customer = response;
        })
        .then(() => {
          return executeRequest(customer.id, toLink, 'link');
        })
        .then(() => {
          return executeRequest(customer.id, toUnlink, 'unlink');
        })
        .then(() => {
          LocalStorageService.clear();
          vm.saving = false;
          vm.modalInstance.close(customer);
        })
        .catch((err) => {
          console.log(err);
          vm.saveError = utils.getHTTPError(err);
          vm.saving = false;
        });
    }

    function executeRequest(customerId, array, operation) {
      let defer = $q.defer();
      let count = 0;
      if (array.length) {
        array.forEach((id) => {
          Customer.toolkits[operation]({ id: customerId, fk: id })
            .$promise.then((result) => {
              count++;
              if (count === array.length) {
                defer.resolve();
              }
            })
            .catch((err) => {
              console.log(err);
              count++;
              if (count === array.length) {
                defer.resolve();
              }
              console.log(err);
            });
        });
      } else {
        defer.resolve();
      }

      return defer.promise;
    }
  }
})();
